// API client for the Onedot6 web app — mirrors the mobile contract.
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_ORIGIN = BASE;
export const API_URL = `${BASE}/api`;

const client = axios.create({ baseURL: API_URL, headers: { "Content-Type": "application/json" } });

function authCfg(token) {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

/**
 * Resolve an uploaded media path to an absolute URL. Defensive against
 * corrupted CMS values (non-string) — returns "" so callers fall back.
 */
export function mediaSrc(path) {
  if (typeof path !== "string" || !path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${API_ORIGIN}${path}`;
}

export const api = {
  // ---- Public content ----
  listProjects: () => client.get("/projects").then((r) => r.data),
  getProject: (id) => client.get(`/projects/${id}`).then((r) => r.data),
  listJournal: () => client.get("/journal").then((r) => r.data),
  getJournal: (id) => client.get(`/journal/${id}`).then((r) => r.data),
  createBooking: (data) => client.post("/bookings", data).then((r) => r.data),
  createGiftingEnquiry: (data) => client.post("/gifting-enquiries", data).then((r) => r.data),

  // ---- Site settings + pages (public GET) ----
  getSettings: () => client.get("/settings").then((r) => r.data),
  getPage: (key) => client.get(`/pages/${key}`).then((r) => r.data),

  // ---- What's New (public) ----
  getWhatsNew: () => client.get("/whats-new").then((r) => r.data),

  // ---- Auth ----
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  twoFactorLogin: (two_factor_token, code) =>
    client.post("/auth/2fa/login", { two_factor_token, code }).then((r) => r.data),
  me: (token) => client.get("/auth/me", authCfg(token)).then((r) => r.data),
  logout: (token) => client.post("/auth/logout", {}, authCfg(token)).then((r) => r.data),
};

export default api;
